import React, { useEffect } from "react";
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";

const ReRouter = ({ children, addToStore, changeStage, nextStep }) => {
  const { application } = useSelector((state) => state);

  const navigate = useNavigate();
  let params = useParams();

  const locationCheck = () => {
    const location = window.location.href;

    if (application.stage === 'people-with-significant-control' && !location.includes('people-with-significant-control')) {
      navigate(`/${application.store.company_id}/people-with-significant-control`);
      return;
    }

    if (location.includes('people-with-significant-control') && application.stage !== 'people-with-significant-control') {
      addToStore('company_id', params.dealID);
      changeStage('people-with-significant-control');
      nextStep(null, 'posc-welcome');
      return;
    }

    if (application.stage === 'bank' && !location.includes('bank')) {
      navigate(`/${application.store.company_id}/bank`);
      return;
    }

    if (location.includes('bank') && application.stage !== 'bank') {
      addToStore('company_id', params.dealID);
      changeStage('bank');
      nextStep(null, 'bank-welcome');
    }
  };

  useEffect(() => {
    locationCheck();
  }, [application.stage]);

  return (
    <React.Fragment>{children}</React.Fragment>
  );
}

export default ReRouter;
